import getNamedChildren from 'utils/get-named-children';

import throttle from 'lodash/throttle';
import debounce from 'lodash/debounce';
import prefix from 'prefix';

let kids;
let scrollHeight;
let projectNodes;

export function init(parent) {
  window.addEventListener('wheel', onScroll, false);
  window.addEventListener('resize', debounce(onResize, 100), false);
  window.addEventListener('touchstart', onTouchStart, false);
  window.addEventListener('touchmove', onTouchMove, false);
  window.addEventListener('touchend', onTouchEnd, false);
  kids = getNamedChildren(parent);
  projectNodes = kids.project_thumb;
  initScroll();
  onResize();
}

const elOffset = 370;

function initScroll() {
  let offsetHeight = -elOffset;
  projectNodes.forEach((el, index) => {
    el.top = 0;
    el.offset = offsetHeight;
    el.height = el.offsetHeight + elOffset;
    offsetHeight += el.height;
  });
  scrollHeight = offsetHeight;
  positionProjects(0, 0);
}

let scrollAmount = 0;
let scrollAmount2 = 0;
let scrollTarget = 0;
let scrollTarget2 = 0;
let animating = false;

function animateProjects() {
  animating = true;
  var distance = (scrollTarget - scrollAmount) / 8;
  var distance2 = (scrollTarget2 - scrollAmount2) / 12;

  scrollAmount += distance;
  scrollAmount2 += distance2;

  if(Math.abs(distance) > 0.05 || Math.abs(distance2) > 0.05) {
    requestAnimationFrame(animateProjects);
  } else {
    animating = false;
  }

  positionProjects(distance, distance2);
}

let tform = prefix('transform');

function positionProjects(distance, distance2) {
  projectNodes.forEach( (el, index) => {
    el.top = el.top + (index % 2 ? distance : distance2);
    let top = el.top + el.offset;
    let btm = top + el.height;
    if(btm < 0) {
      el.top += scrollHeight + elOffset;
    } else if(btm > scrollHeight) {
      el.top -= scrollHeight + elOffset;
    }
    if(!animating) el.top = Math.round(el.top/10) * 10;
    el.style[tform] = `translateY(${el.top + el.offset}px)`;
  });
}

let touchStartY;
let touchTargetY;
let touchLastY;
let touchTimer;
let touchVelocity;
let touchAmount;
let touchScrolling = false;

function onTouchStart(e) {
  if(typeof scrollHeight === 'undefined') { initScroll() }
  window.removeEventListener('wheel', onScroll);
  touchScrolling = true;
  touchTargetY = scrollTarget;
  touchStartY = e.touches[0].clientY;
  touchLastY = touchStartY;
  touchTimer = new Date().getTime();
}

function onTouchMove(e) {
  e.preventDefault();
  onTouchScroll(e.changedTouches[0].clientY);
}

let _onTouchScroll = throttle(onTouchScroll, 66);

function onTouchScroll(currentY) {
  if(!touchScrolling) return;
  let currentTime = new Date().getTime();
  let amount = currentY - touchStartY;
  touchAmount = currentY - touchLastY;
  let velocity = touchAmount / (currentTime - touchTimer);
  touchVelocity = velocity;
  //amount *= velocity;
  scrollTarget = touchTargetY + (Math.ceil(amount/10) * 10);
  scrollTarget2 = touchTargetY + (Math.ceil(amount/10) * 10);
  if(!animating) { animateProjects() }
  touchLastY = currentY;
  touchTimer = currentTime;
}

function onTouchEnd(e) {
  touchScrolling = false;
  scrollTarget += 300 * touchVelocity;
  scrollTarget2 += 300 * touchVelocity;
}

function onScroll(e) {
  if(typeof scrollHeight === 'undefined') { initScroll() }
  //window.removeEventListener('touchstart', onTouchStart);
  //window.removeEventListener('touchmove', onTouchMove);
  scrollTarget += Math.ceil(e.deltaY/10) * 10;
  scrollTarget2 += Math.ceil(e.deltaY/10) * 10;
  if(!animating) { animateProjects() }
}

function onResize(e) {
  let h = window.innerHeight;
  let hh;
  hh = kids.heading.offsetHeight;
  kids.heading.style.top = (Math.round(((h - hh) / 2)/10) * 10) + 'px';
}



/** WEBPACK FOOTER **
 ** ./scroll/index.js
 **/